<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content style="min-width: 400px;">
  <p>{{text}}</p>

  <div>
    Currency:
    <span *ngIf="data.currencyCode == 978">EUR</span>
    <span *ngIf="data.currencyCode == 578">NOK</span>
  </div>

  <div style="margin-top: 10px; margin-bottom: 10px;">
      <mat-checkbox [(ngModel)]="isClosed">Closed</mat-checkbox>

  </div>

  <div>
    <mat-form-field class="full-width">
      <input matInput placeholder="Wallet Name" [(ngModel)]="customName" required/>
    </mat-form-field>
  </div>

  <div style="margin-top: 10px;">
    <mat-form-field class="full-width">
      <input matInput placeholder="Wallet IBAN" [(ngModel)]="walletIban" />
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="full-width">
      <input matInput placeholder="Wallet BIC" [(ngModel)]="walletBic" />
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="full-width">
      <input matInput placeholder="Revolut Account ID" [(ngModel)]="revolutAccountId" />
    </mat-form-field>
    <small>
      <div style="padding: 3px 3px; margin: 5px 0; background-color: #8bc5ff">Fill out only if Instant Loads should be active!</div>
      Log in to Revolut Business, select the designated account, click the three dots and then "Details"<br />
      The URL you are on looks like this:<br />
      https://business.revolut.com/accounts/<b>00000000-0000-0000-0000-000000000000</b><br />
      <br />
      <b>Copy and paste the bold part!</b>
    </small>
  </div>

  <div>
    <mat-form-field class="full-width">
      <input matInput placeholder="Sender filter" [(ngModel)]="senderFilter" />
    </mat-form-field>
    <small>Allow only senders containing this value</small>
  </div>

  <div style="margin-top: 10px;">
    <mat-form-field class="full-width">
      <input matInput placeholder="Notification E-Mail" [(ngModel)]="notificationEmail" />
    </mat-form-field>

  </div>

  <div>
    <mat-form-field class="full-width">
      <input matInput placeholder="Top-Up Fee" [(ngModel)]="loadFee" />
    </mat-form-field>
    <small>
      A fee that is taken upon loading the wallet
    </small>
  </div>

  <div>
    <mat-form-field>
      <input matInput placeholder="Brand Referral URL {{brandReferralURLHintText}}"  [(ngModel)]="brandReferralCode"
             maxlength="50">
      <mat-hint><a [routerLink]="brandReferralUrlLink" style="text-decoration:none">Go to URL</a></mat-hint>
    </mat-form-field>
  </div>

</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="basic">Cancel</button>
  <button mat-raised-button (click)="onYesClick()" color="primary" [disabled]="!customName">Save</button>
</div>

